import React, { useState } from "react";
import uploadImage from "../../assets/images/icons/upload.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const ImageUploaderMutli = ({ setFile, title }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const fileObjects = files.map((file) => ({
      file: file,
      name: file.name,
      type: file.type,
      preview: URL.createObjectURL(file),
      downloadURL: null,
    }));

    setSelectedFiles((prevFiles) => [...prevFiles, ...fileObjects]);
    setFile((prevFiles) => [...prevFiles, ...fileObjects]);
  };

  const handleDelete = (index) => {
    const updatedFiles = selectedFiles.filter((_, i) => i !== index);
    setSelectedFiles(updatedFiles);
    setFile(updatedFiles);
  };

  return (
    <div className="image-uploader">
      <div className="file-upload-info file-up">
        <div className="image-upload">
          <img src={uploadImage} alt="upload icon" loading="lazy" />
        </div>
        <div className="info-content">
          <h2 className="title">{title}</h2>
        </div>
        <input type="file" accept="image/*" onChange={handleFileChange} multiple />
      </div>
      {selectedFiles.length > 0 && (
        <div className="d-flex justify-content-center mt-4 flex-wrap">
          {selectedFiles.map((file, index) => (
            <div key={index} className="main-upload-info m-2">
              <img
                src={file.preview}
                alt={file.name}
                style={{ width: "100px", height: "auto" }}
              />
              <div
                className="button-remove-up d-flex justify-content-center align-items-center"
                onClick={() => handleDelete(index)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImageUploaderMutli;
